import React, { FunctionComponent } from 'react';

const CongressionalOutreachFooter: FunctionComponent = () => {
  return (
    <div className="outreachFooterContainer">
      <div className="outreachFooterDivOne">
        <p>
          Phone: <a href="tel:(202) 833-8990">(202) 833-8990</a>
        </p>
      </div>
      <div className="outreachFooterDivTwo">
        <p>|</p>
      </div>
      <div className="outreachFooterDivThree">
        <p>
          Email: <a href="mailto:bahaisus@usbnc.org">bahaisus@usbnc.org</a>
        </p>
      </div>
    </div>
  );
};

export default CongressionalOutreachFooter;
